// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1va5Q","item":"styles_item__opkKj","finish":"styles_finish__2ncmu","icon":"styles_icon__3j-yX","user":"styles_user__18ajC"};